import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Select2OptionData } from 'ng-select2';

@Component({
  selector: 'filter-tag-checkbox-multi',
  templateUrl: './filter-tag-checkbox-multi.component.html',
  styleUrls: ['./filter-tag-checkbox-multi.component.css']
})
export class FilterTagCheckboxMultiComponent {

  @Input() controlArray: FormArray;
  @Input() label: string = '';
  @Input() dataSelectLabel: Array<Select2OptionData> | Array<string> = [];

  constructor() { }



  onRemoveOption(index: number) {
    this.controlArray.controls[index].setValue(false);
  }
}
